module.exports = __webpack_public_path__ + "static/img/cmef-ly.2d463434.png";